// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sen-styles-learnMore-yRSAsqVO{display:flex;align-items:center}.sen-styles-info-ZZzscD9f{margin-left:2px;transform:translateY(1.5px)}`, "",{"version":3,"sources":["webpack://./src/components/ListViewLearnMoreHeader/styles.scss"],"names":[],"mappings":"AAEA,+BACE,YAAA,CACA,kBAAA,CAEF,0BACE,eAAA,CACA,2BAAA","sourcesContent":["@import \"@densityco/ui/variables/colors.scss\";\n\n.learnMore {\n  display: flex;\n  align-items: center;\n}\n.info {\n  margin-left: 2px;\n  transform: translateY(1.5px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"learnMore": `sen-styles-learnMore-yRSAsqVO`,
	"info": `sen-styles-info-ZZzscD9f`
};
export default ___CSS_LOADER_EXPORT___;
